import { I18nContext, useTranslator } from "../i18n/context.js";
import { useComposedRefs } from "../utils/use-composed-refs.js";
import { useContainerAttach, usePlayer } from "./context.js";
import { PopupGroupProvider } from "./popup-group-context.js";
import { ContainerCore, ContainerDataAttrs } from "@videojs/core";
import { DEFAULT_CONTAINER_ROLE, DEFAULT_CONTAINER_TAB_INDEX, createPopupGroup, focusContainer, getStateDataAttrs, selectControls } from "@videojs/core/dom";
import { forwardRef, useContext, useEffect, useRef, useState } from "react";
import { jsx } from "react/jsx-runtime";
import { labelText } from "@videojs/core/i18n/text/container";
import { getTextDirection } from "@videojs/utils/i18n";
//#region src/player/container.tsx
const Container = forwardRef(function Container({ children, tabIndex = DEFAULT_CONTAINER_TAB_INDEX, role = DEFAULT_CONTAINER_ROLE, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, lang: langProp, dir: dirProp, ...props }, ref) {
	const setContainer = useContainerAttach();
	const translator = useTranslator();
	const i18n = useContext(I18nContext);
	const controls = usePlayer(selectControls);
	const [core] = useState(() => new ContainerCore());
	const [popupGroup] = useState(() => createPopupGroup());
	const internalRef = useRef(null);
	const composedRef = useComposedRefs(ref, internalRef);
	useEffect(() => {
		setContainer?.(internalRef.current);
		return () => setContainer?.(null);
	}, [setContainer]);
	const handlePointerUp = (event) => {
		props.onPointerUp?.(event);
		const el = internalRef.current;
		if (!el) return;
		focusContainer(el);
	};
	const accessibleNameProps = ariaLabel !== void 0 || ariaLabelledBy !== void 0 ? {
		"aria-label": ariaLabel,
		"aria-labelledby": ariaLabelledBy
	} : { "aria-label": translator(labelText) };
	const lang = langProp ?? (i18n?.localeFromProp ? i18n.locale : void 0);
	const localeProps = {
		lang,
		dir: dirProp ?? (lang ? getTextDirection(lang) : void 0)
	};
	if (controls) core.setMedia(controls);
	const stateAttrs = controls ? getStateDataAttrs(core.getState(), ContainerDataAttrs) : void 0;
	return /* @__PURE__ */ jsx("div", {
		ref: composedRef,
		role,
		tabIndex,
		...accessibleNameProps,
		...localeProps,
		...props,
		...stateAttrs,
		onPointerUp: handlePointerUp,
		children: /* @__PURE__ */ jsx(PopupGroupProvider, {
			value: popupGroup,
			children
		})
	});
});
//#endregion
export { Container };

//# sourceMappingURL=container.js.map